import ai from './ai/apis';
import baseInfo from './baseInfo/apis';
import card from './card/apis';
import cardTransfer from './cardTransfer/api';
import crm from './crm/apis';
import directDebit from './directDebit/apis';
import external from './external/apis';
import fund from './fund/apis';
import fundTransfer from './fundTransfer/apis';
import notification from './notification/apis';
import paymentService from './paymentService/apis';
import pellekan from './pellekan/apis';
import register from './register/apis';
import sm from './sm/apis';
import tbs from './tbs/apis';
import trade from './trade/apis';
import user from './user/apis';
import webview from './webview/apis';

const apis = {
  baseInfo,
  card,
  cardTransfer,
  pellekan,
  user,
  trade,
  tbs,
  fund,
  webview,
  crm,
  external,
  notification,
  directDebit,
  register,
  sm,
  paymentService,
  fundTransfer,
  ai,
};

export default apis;
